import React, { PureComponent } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { isNull } from 'lodash/fp';
import { isRecurringAssignment } from 'selectors/assign';
import DateFormat from 'constants/date_format';
import Option from './SelectableItem.jsx';

class SchedulingOptions extends PureComponent {
  renderOption(label) {
    return <Option label={label} shrinked />;
  }

  render() {
    const dateFormat = DateFormat.SHORT;
    const { renderOption, props } = this;
    const { assignDate, dueDate, recurring, canSchedule } = props;
    return (
      <div className="AssignStep-selectedItems">
        {canSchedule &&
          isNull(assignDate) &&
          renderOption('Assign Immediately')}
        {canSchedule &&
          assignDate &&
          renderOption(`Assign on ${moment(assignDate).format(dateFormat)}`)}
        {dueDate && renderOption(`Due ${moment(dueDate).format(dateFormat)}`)}
        {recurring && renderOption('Recurring Assignment')}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  assignDate: state.schedule.assignDate,
  dueDate: state.schedule.dueDate,
  recurring: isRecurringAssignment(state),
  canSchedule: state.meta.features.scheduled_assignments,
});

export default connect(mapStateToProps)(SchedulingOptions);
